export default __webpack_public_path__ + "static/media/subscriptions.ac0395c9.svg";